export function createBlockId(blockName) {
  return `${blockName}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function deepCloneWithFreshIds(obj) {
  if (typeof obj !== 'object' || !obj) return obj;
  if (Array.isArray(obj)) return obj.map(deepCloneWithFreshIds);
  const result = {};
  for (const [k, v] of Object.entries(obj)) {
    result[k] = (k === 'id' || k === 'lexicalId') ? crypto.randomUUID() : deepCloneWithFreshIds(v);
  }
  return result;
}